import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=aff2de14&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=aff2de14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff2de14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff2de14')) {
      api.createRecord('aff2de14', component.options)
    } else {
      api.reload('aff2de14', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=aff2de14&scoped=true&", function () {
      api.rerender('aff2de14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oi3yHWFNmE2Z/JS/comp/SearchFilterTokens.vue"
export default component.exports